import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import { useSelector } from "react-redux";
import { getRole } from "../../helpers/ReduxHelpers";
import { getPageNameFromPath, getMainMenuFromPath, getSubmenuFromPath } from "./pathToMenuMapper";

export const PageviewEvent = () => {
  const location = useLocation();
  const prevPathRef = useRef(location.pathname);
  const startTimeRef = useRef(Date.now());
  const userInfo = useSelector((state) => state.user.userInfo);

  useEffect(() => {
    const now = Date.now();
    const prevPath = prevPathRef.current;
    const durationSec = Math.floor((now - startTimeRef.current) / 1000);

    // Get user context for events
    const getUserContext = () => {
      if (!userInfo?.id) return {};
      
      const roles = getRole();
      return {
        user_name: userInfo?.merchant?.name || 'Unknown',
        user_role: roles.join(', ') || 'Unknown',
        primary_role: roles[0] || 'Unknown',
        merchant_id: userInfo?.merchant?.id || 'Unknown'
      };
    };

    const userContext = getUserContext();

    // Get meaningful page names from the path
    const currentPageName = getPageNameFromPath(location.pathname);
    const currentMainMenu = getMainMenuFromPath(location.pathname);
    const currentSubmenu = getSubmenuFromPath(location.pathname);

    if (prevPath && prevPath !== location.pathname) {
      const prevPageName = getPageNameFromPath(prevPath);
      const prevMainMenu = getMainMenuFromPath(prevPath);
      const prevSubmenu = getSubmenuFromPath(prevPath);
      
      // Send time on page event with user context using gtag
      ReactGA.gtag('event', 'time_on_page', {
        event_category: 'Page Timing',
        event_label: prevPageName,
        value: durationSec,
        page_path: prevPath,
        page_name: prevPageName,
        main_menu: prevMainMenu,
        submenu_name: prevSubmenu,
        duration_seconds: durationSec,
        ...userContext
      });
    }

    // Send page view with user context using gtag
    ReactGA.gtag('event', 'page_view_custom', {
      event_category: 'Navigation',
      event_label: currentPageName,
      page_path: location.pathname,
      page_name: currentPageName,
      main_menu: currentMainMenu,
      submenu_name: currentSubmenu,
      page_search: location.search,
      full_url: location.pathname + location.search,
      ...userContext
    });

    // Also send standard pageview with enhanced page title
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
      title: currentPageName,
    });

    // console.log('Sent page_view_custom event with meaningful page names using gtag:', {
    //   page: location.pathname,
    //   pageName: currentPageName,
    //   mainMenu: currentMainMenu,
    //   submenu: currentSubmenu,
    //   userContext
    // });

    startTimeRef.current = now;
    prevPathRef.current = location.pathname;
  }, [location, userInfo?.id, userInfo?.merchant?.name, userInfo?.merchant?.id]);

  return null;
};
